import { render, staticRenderFns } from "./Verificate.vue?vue&type=template&id=77d122f3&scoped=true"
import script from "./Verificate.vue?vue&type=script&lang=js"
export * from "./Verificate.vue?vue&type=script&lang=js"
import style0 from "./Verificate.vue?vue&type=style&index=0&id=77d122f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d122f3",
  null
  
)

export default component.exports